import React from "react";
import { ButtonToolbar } from "react-bootstrap";
import { OrderByDropdown } from "./parts/OrderByDropdown";
import { ViewModeToggleButtons } from "./parts/ViewModeToggleButtons";
import { MobileFilterButton } from "pages/redesign/menuFilterBar/parts/FilterButton";
import { AddFilterButton } from "pages/search/searchBar/AddClearFilterButtons";
import { getPathname } from "lib/routing";
import useIsMobile from "lib/hooks/useIsMobile";

export function Toolbar({ viewMode, setViewMode, aggregations }) {
  const isMobile = useIsMobile();

  return (
    <ButtonToolbar className="pb-1">
      <OrderByDropdown />
      <ButtonToolbar className="ml-auto">
        {isMobile && aggregations && <MobileFilterButton aggregations={aggregations} />}
        <ViewModeToggleButtons viewMode={viewMode} setViewMode={setViewMode} />
      </ButtonToolbar>
    </ButtonToolbar>
  );
}

const FilterButton = () => {
  const showFilterButton = !(getPathname() === "/Search_Results" || getPathname() === "/My_Research");
  return showFilterButton && <AddFilterButton className="mr-2 d-none d-sm-block" />;
};
